var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 80,
    width: 182,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse",
    id: "mask0_118_481"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    fill: "#D9D9D9",
    height: 80,
    width: 182
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_2",
    mask: "url(#mask0_118_481)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#0BB3F0",
    id: "svg_3",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "m43.29684,18.86091c13.54503,-2.15883 27.02841,-4.05662 40.67017,-4.38265c15.36433,-0.3671 30.97239,-0.68921 46.27038,1.46921c7.57007,1.06806 15.11443,2.84122 22.56417,4.95537c6.51801,1.84951 13.35174,3.92817 19.28408,8.26717c2.27997,1.66771 4.89622,3.96459 5.52766,7.69445c1.05103,6.20884 -2.52987,12.08907 -5.92668,15.38901c-5.0618,4.91751 -11.53147,7.32643 -17.43502,9.38775c-10.5586,3.68684 -21.37431,6.15106 -32.18796,7.86882c-14.33027,2.27634 -28.79269,3.3376 -43.2078,3.88463c-18.08599,0.68632 -37.42396,1.80153 -55.27785,-3.28694c-5.58376,-1.59147 -22.68558,-6.62887 -19.08453,-20.41908c2.97209,-11.3816 15.30711,-16.1559 21.71251,-18.87517c14.13215,-5.9994 30.98864,-9.08256 45.49116,-11.80317c31.32101,-5.87579 62.70373,-8.5151 94.26231,-10.01031"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVideos);
export default __webpack_public_path__ + "static/media/social-videos.9b7ce93288ae4d41244459a23ffb6f34.svg";
export { ForwardRef as ReactComponent };